export default __webpack_public_path__ + "static/media/nba-double.cc2b6ea7.png";